import { Container, Section } from "@/components/ui/section";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    question: "How does Casey interview customers?",
    answer: "Casey runs asynchronous AI-led interviews that feel human and ask smart follow-ups."
  },
  {
    question: "Will customers actually respond?",
    answer: "Yes — no scheduling, flexible timing, and branded experience increases response rates."
  },
  {
    question: "Does this replace human interviews?",
    answer: "It depends on your needs. While Casey can replace deep-dive interviews for creating long-form collateral like case studies and testimonials, you might still want to stay involved for strategic conversations or nuanced feedback sessions."
  },
  {
    question: "How accurate is the content?",
    answer: "Generated from real transcripts; your team reviews before publishing."
  },
  {
    question: "Is data secure?",
    answer: "Yes. Data is stored securely with enterprise-grade options available."
  },
  {
    question: "Do we need engineering?",
    answer: "No. You can launch your first interview in minutes."
  }
];

export const FAQ = () => {
  return (
    <Section id="faq" className="bg-background">
      <Container>
        <div className="text-center mb-12 max-w-3xl mx-auto">
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-6 leading-tight">
            Frequently asked questions
          </h2>
        </div>

        <div className="max-w-3xl mx-auto">
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((faq, index) => (
              <AccordionItem key={index} value={`item-${index}`}>
                <AccordionTrigger className="text-left text-lg font-semibold text-foreground">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </Container>
    </Section>
  );
};
